import type { VideoThumbnailCandidatePayload, VideoThumbnails } from '../types';

// The snake_case thumbnail fields of the community video payload.
export type VideoThumbnailsPayload = {
  thumbnail_url?: string | null;
  thumbnail_candidate_index?: number | null;
  thumbnail_candidates?: VideoThumbnailCandidatePayload[] | null;
};

export const toVideoThumbnails = (video: VideoThumbnailsPayload): VideoThumbnails => ({
  selectedUrl: video.thumbnail_url ?? null,
  selectedIndex: video.thumbnail_candidate_index ?? null,
  candidates:
    video.thumbnail_candidates?.map(({ index, url, preview_url }) => ({ index, url, previewUrl: preview_url })) ?? null,
});
